import React from 'react'
import styles from './styles.scss'
import { reduxForm } from 'redux-form'
import FieldWrapper from 'components/FieldWrapper'
import { Button, TYPES } from "components/Button"

class LoginForm extends React.Component {
  render() {
    const { handleSubmit, submitText } = this.props
    return (
      <form className={styles.loginForm} onSubmit={handleSubmit}>
      <h2>Fixarfolket Admin</h2>
      <FieldWrapper
          label="E-post"
          name="email"
          component="input"
          type="text"
        />
      <FieldWrapper
          label="Lösenord"
          name="password"
          component="input"
          type="password"
        />
      <Button buttonType={TYPES.SUCCESS}>{submitText}</Button>
      </form>
    )
  }
}
LoginForm = reduxForm({
  form: "loginForm",
})(LoginForm)
export default LoginForm


// WEBPACK FOOTER //
// src/pages/LoginPage/LoginForm/index.jsx